import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextareaAutosize,
  InputAdornment,
  Autocomplete,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import download_btn from "../../Admin/assets/icons/download_button.svg";
import Image from "../../Utils/getImage";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import phone from "../../Admin/assets/icons/ic_baseline-phone.svg";
import { useNavigate } from "react-router-dom";
import consultation_image from '../../Admin/assets/images/consultation-cancel.svg'
import consultation_hold from '../../Admin/assets/images/hold-consultation.svg'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ViewConsultationInfo = ({
  openviewDialog,
  setopenviewCancelDialog,
  setopenviewDialog,
  customerdata,
  openDialog,
  setOpenDialog,
  edit,
  download,
  editData,
  setEdit,
  handleConsultationData,
  // setopenviewDialog
}) => {

  const [confirmCancelDialog, setConfirmCancelDialog] = useState(false);
  const [confirmBookDialog, setConfirmCBookDialog] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState("");
  const [employeeData, setEmployeeData] = useState();
  // const [commants, setCommants] = useState("");
  const [newComment, setNewComment] = useState(""); // Stores the new comment
  const [commentsList, setCommentsList] = useState([]); // Stores all comments
  const [confirmFinishDialog, setConfirmFinishDialog] = useState(false);

  const [bookData, setBookData] = useState({
    consultation_type: "",
    consultation_date: "",
  });
  const [status, setStatus] = useState("");
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  // console.log("edit",edit);
  // console.log("editData",editData);

  useEffect(() => {
    setSelectedPerson(customerdata?.assigned_to);
    setBookData({ ...bookData, consultation_type: customerdata?.consultation_type, consultation_date: dayjs(customerdata?.consultation_date) });
    // Ensure commentsList is always an array
    if (customerdata?.comments) {
      setCommentsList(Array.isArray(customerdata.comments) ? customerdata.comments : [customerdata.comments]);
    }
  }, [openviewDialog]);

  //handle close
  const handleClose = () => {
    setopenviewDialog(false);
    // setopenviewDialog(true);
    // setOpenDialog(true);
    // setEdit(true);
    setSelectedPerson("");
    setStatus("");
    setNewComment("");
    setCommentsList([]);
    setBookData({ consultation_type: "", consultation_date: "" });
  };

  const EmployeeData = async () => {
    try {
      const response = await instance.get("/Admin/getAdmins");
      setEmployeeData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    EmployeeData();
  }, []);


  // Function to add a new comment to the list
  const handleAddComment = () => {
    if (newComment.trim()) {
      setCommentsList((prev) => [...prev, newComment.trim()]);
      setNewComment(""); // Clear input field
    } else {
      toast.error("Comment cannot be empty!");
    }
  };
  // // Function to add a new comment to the list
  const handleAddComment1 = () => {
    if (newComment.trim()) {
      const comments = [...commentsList, newComment.trim()];
      handleBookConsultation(customerdata?._id, comments)
    } else {
      toast.error("Comment cannot be empty!");
    }
  };

  const handleBookConsultation = async (id, commentData) => {

    // if (commentsList.length === 0) {
    //   return toast.error("Please add a comment before updating.");
    // }

    if (!bookData.consultation_type) {
      return toast.error("Please select a consultation type.");
    }

    if (!bookData.consultation_date) {
      return toast.error("Please select a consultation date.");
    }

    if (!selectedPerson) {
      return toast.error("Please select an admin.");
    }
    try {
      const response = await instance.patch("/Consultation/bookConsultation", {
        consultation_id: id,
        consultation_type: bookData.consultation_type,
        consultation_date: bookData.consultation_date,
        comments: commentData ? commentData : commentsList,
        admin_id: selectedPerson,
      });
      if (response.data.success === true) {
        toast.success(response.data.message);
        handleConsultationData();
        handleClose();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };


  const handleCancelConsultation = async (customerdata) => {
    try {
      const response = await instance.patch('/Consultation/finishConsultation', {
        consultation_id: customerdata,
        status: "Cancelled"
      });
      if (response.data.success === true) {
        // toast.success(response.data.message);
        toast.success("Consultation Cancelled" || response.data.message);
        handleClose();
        handleConsultationData();
      } else {
        toast.error(response.data.message);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const handleBookpopupConsultation = async (customerdata) => {
    try {
      const response = await instance.patch('/Consultation/finishConsultation', {
        consultation_id: customerdata,
        status: "Hold"
      });
      if (response.data.success === true) {
        // toast.success(response.data.message);
        toast.success("Consultation on hold" || response.data.message);
        handleClose();
        handleConsultationData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleFinishconsultation = async (customerdata) => {
    try {
      const response = await instance.patch('/Consultation/finishConsultation', {
        consultation_id: customerdata,
        status: "Completed"
      });
      if (response.data.success === true) {
        toast.success(response.data.message);
        handleClose();
        handleConsultationData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error)
    }

  }


  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={edit ? openDialog : openviewDialog}
        className="admin-admins"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {"Consultation Info"}
          <div className="consultation-popup"></div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <section className="add-consultantation">
            {/* <div className="add-employee-title">
              <Typography>
                {"consultation Person info"}
              </Typography>
            </div> */}
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_emloyee-upload-file">
                  <Typography variant="h5">
                    {customerdata?.name
                      ? customerdata?.name
                      : customerdata?.Customer?.name}
                  </Typography>
                  <Image
                    src={customerdata?.Customer?.profile_pic}
                    alt="upload_image"
                    width={220}
                    height={171}
                  />
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <div className="ph-num">
                      <img src={phone} alt="" />
                      <Typography>
                        {customerdata?.mobile
                          ? customerdata?.mobile
                          : customerdata?.Customer?.mobile}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="add_emloyee-content">
                  <div className="consultation-form">
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">Requirements</Typography>
                      <Typography>
                        {customerdata?.reason
                          ? customerdata?.reason
                          : "---"}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="add_emloyee-content" style={{ marginTop: 10 }}>
                  <div className="consultation-form">
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">Address</Typography>
                      {customerdata?.Customer?.location
                        ? customerdata.Customer.location
                          .split(",")
                          .map((part, index) => (
                            <Typography key={index}>{part.trim()}</Typography>
                          ))
                        : "10-2-289/34, Shanti Nagar, Hyderabad, Telangana 500028"
                          .split(",")
                          .map((part, index) => (
                            <Typography key={index}>{part.trim()}</Typography>
                          ))}
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <div className="add_emloyee-content">
                  <ul className="add_emloyee-content-text">
                    <Typography variant="h5">Existing Comments:</Typography>
                    <div style={{ width: "407px", height: '100px', overflowY: "scroll" }} >
                      {commentsList.map((comment, index) => (
                        <li key={index}>{comment}{comment?.length === 0 ? "...." : ","}</li>
                      ))}
                    </div>
                  </ul>
                </div>
                {editData === false ? null :
                  <div className="add_emloyee-content">
                    <div className="add_emloyee-content-text">
                      <Typography variant="h5">Enter Comments:</Typography>
                      <TextareaAutosize
                        minRows={3}
                        maxRows={6}
                        placeholder="Add Comments..."
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        style={{
                          width: "400px",
                          height: "30px",
                          padding: "8px",
                          borderRadius: "2px",
                          border: "1px solid #ccc",
                          fontSize: "16px",
                        }}
                        disabled={customerdata?.status === "Cancelled"}
                      />
                      {/* {role != 'Admin' ?
                        (
                          <>
                            <Button
                              className="add-btn"
                              onClick={handleAddComment1}
                              disabled={customerdata?.status === "Cancelled"}
                            >
                              Add Comment
                            </Button>
                          </>
                        ) : ( */}
                      <Button
                        className="add-btn"
                        onClick={handleAddComment}
                        disabled={customerdata?.status === "Cancelled"}
                      >
                        Add Comment
                      </Button>
                      {/* )} */}
                    </div>
                  </div>}
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_employee-content">
                  <div className="add_employee-content-text">
                    {editData === false ?
                      (
                        <>
                          <Typography variant="h5">Consultation Type</Typography>
                          <Typography> {customerdata?.consultation_type
                            ? customerdata?.consultation_type
                            : "----"}</Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h5">Consultation Type</Typography>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required>
                              <Select
                                value={bookData?.consultation_type ? bookData?.consultation_type : null}
                                onChange={(e) =>
                                  setBookData({
                                    ...bookData,
                                    consultation_type: e.target.value,
                                  })
                                }
                                displayEmpty
                                disabled={customerdata?.status === "Cancelled"}
                              >
                                <MenuItem value="" disabled>
                                  <em>Select Type</em>
                                </MenuItem>
                                <MenuItem value="In Person">{"In Person"}</MenuItem>
                                <MenuItem value="Online">{"Online"}</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_employee-content">
                  <div className="add_employee-content-text">
                    {editData === false ?
                      (
                        <>
                          <Typography variant="h5">Date Of Consultation</Typography>
                          <Typography> {customerdata?.consultation_date
                            ? new Date(customerdata.consultation_date).toLocaleDateString("en-GB")
                            : "----"}</Typography>
                        </>
                      ) : (
                        <div className="admin-textfiled">
                          <Typography variant="h5">Date Of Consultation</Typography>
                          <FormControl fullWidth required>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                  minDate={dayjs()}
                                  value={bookData?.consultation_date ? dayjs(bookData.consultation_date) : null}
                                  onChange={(newDate) => setBookData({ ...bookData, consultation_date: newDate ? newDate.toISOString() : null })}
                                  disabled={customerdata?.status === "Cancelled"}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </FormControl>
                        </div>
                      )}
                  </div>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_employee-content">
                  <div className="add_employee-content-text">
                    {editData === false ?
                      (
                        <>
                          <Typography variant="h5">Assigned Designer</Typography>
                          <Typography> {customerdata?.Admin?.name
                            ? customerdata?.Admin?.name
                            : "----"}</Typography>
                        </>
                      ) : (
                        <>
                          <Typography variant="h5">Assigned Designer</Typography>
                          {/* <div className="admin-textfiled">
                            <FormControl fullWidth required>
                              <Select
                                value={selectedPerson ? selectedPerson : null}
                                onChange={(e) => setSelectedPerson(e.target.value)}
                                disabled={customerdata?.status === "Cancelled"}
                              >
                                <MenuItem value="" disabled>
                                  <em>Assign person</em>
                                </MenuItem>
                                {employeeData?.map((data) => (
                                  <MenuItem key={data._id} value={data._id}>
                                    {data.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div> */}
                          <div className="admin-textfiled">
                            <Autocomplete
                              options={employeeData || []}
                              getOptionLabel={(option) => option.name || ""}
                              value={employeeData?.find((item) => item._id === selectedPerson) || null}
                              onChange={(event, newValue) => {
                                setSelectedPerson(newValue?._id || "");
                              }}
                              disabled={customerdata?.status === "Cancelled"}
                              slotProps={{
                                paper: {
                                  sx: {
                                    maxHeight: 200,
                                    overflowY: "auto",
                                  }
                                },
                                listbox: {
                                  sx: {
                                    "& .MuiAutocomplete-option": {
                                      padding: "10px 16px",
                                    },
                                  }
                                }
                              }}
                              size="small"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      height: "9px !important",
                                      // padding: "10px 14px",  
                                    }
                                  }}
                                  variant="outlined"
                                  fullWidth
                                />
                              )}
                            />
                          </div>

                        </>
                      )}
                  </div>
                </div>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                <div className="add_employee-content">
                  <div className="add_employee-content-text">
                    <Typography variant="h5">Status</Typography>
                    <Typography> {customerdata?.status
                      ? customerdata.status
                      : "----"}</Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </section>
        </DialogContent>
        {editData === false ? null :
          <DialogActions>
            {customerdata?.status !== "Cancelled" && customerdata?.status !== "Hold" && (
              <Button
                className="hold_btn common_btn"
                onClick={() => setConfirmCBookDialog(true)}>
                Hold Consultation
              </Button>
            )}

            {customerdata?.status !== "Cancelled" && customerdata?.status !== "Hold" &&(
              <Button
                className="cancel_btn common_btn"
                onClick={() => setConfirmCancelDialog(true)}>
                Cancel Consultation
              </Button>
            )}

            {customerdata?.status !== "Cancelled" && customerdata?.status !== "Completed" && !customerdata?.Order && (
              <Button
                onClick={() => {
                  setopenviewDialog(false);
                  navigate(`/admin/addtocart/${customerdata?.Customer?._id}?consultation_id=${customerdata?._id}`)
                }
                }
                className="order_btn common_btn"
              >
                Place Order
              </Button>
            )}

            {/* {download ? null : (
            <Button className="download-btn">
              Download <img src={download_btn} alt="download" />
            </Button>
          )} */}
            {/* {editData === true && !customerdata?.Admin ? (
            <Button onClick={handleassign} className="add-btn">
              {"Assign"}
            </Button>
          ) : null} */}
            {/* {editData === true &&
            customerdata?.Admin &&
            !customerdata?.consultation_date ? (
            <Button
              onClick={() => handleBookConsultation(customerdata?._id)}
              className="add-btn"
            >
              {"Book"}
            </Button>
          ) : null} */}
            {customerdata?.status !== "Cancelled" && customerdata?.status !== "Completed" && customerdata?.status !== "Booked" && (
              <Button
                className="add_btn common_btn"
                onClick={() => handleBookConsultation(customerdata?._id)}
              >
                Update
              </Button>
            )}

            {customerdata?.status !== "Cancelled" && customerdata?.status !== "Completed"  && (
              // <Button className="add_btn common_btn"
              //   onClick={() => handleFinishconsultation(customerdata?._id)}>
              //   Finish Consultation
              // </Button>
              <Button
                className="add_btn common_btn"
                onClick={() => setConfirmFinishDialog(true)}
              >
                Finish Consultation
              </Button>

            )}
          </DialogActions>
        }
      </BootstrapDialog>
      <>
        {confirmCancelDialog && (
          <Dialog
            open={confirmCancelDialog}
            onClose={() => setConfirmCancelDialog(false)}
            className="admin-admins"
          >
            {/* <DialogTitle>Cancel Consultation</DialogTitle> */}
            <DialogContent>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <img src={consultation_image} alt="consultation_image" />
                <Typography variant="h5">Are you sure you want to cancel this consultation?</Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setConfirmCancelDialog(false)}
                className="cancel-btn"
              >
                No
              </Button>
              <Button
                onClick={() => {
                  handleCancelConsultation(customerdata?._id);
                  setConfirmCancelDialog(false);
                }}
                className="add-btn"
              >
                Yes, Cancel
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </>
      <>
        {confirmBookDialog && (
          <Dialog
            open={confirmBookDialog}
            onClose={() => setConfirmCBookDialog(false)}
            className="admin-admins"
          >
            {/* <DialogTitle>Cancel Consultation</DialogTitle> */}
            <DialogContent>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <img src={consultation_hold} alt="consultation_hold" />
                <Typography variant="h5">Are you sure you want to Hold this consultation?</Typography>
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setConfirmCBookDialog(false)}
                className="cancel-btn"
              >
                No
              </Button>
              <Button
                onClick={() => {
                  handleBookpopupConsultation(customerdata?._id);
                  setConfirmCBookDialog(false);
                }}
                className="add-btn"
              >
                Yes, Hold
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </>
      <>
        {confirmFinishDialog && (
          <Dialog
            open={confirmFinishDialog}
            onClose={() => setConfirmFinishDialog(false)}
            className="admin-admins"
          >
            <DialogContent>
              <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <img
                  src={consultation_image}
                  alt="finish_consultation_icon"
                  style={{ width: "100px", marginBottom: "15px" }}
                />
                <Typography variant="h5">
                  Are you sure you want to finish this consultation?
                </Typography>
              </div>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setConfirmFinishDialog(false)}
                className="cancel-btn"
              >
                No
              </Button>

              <Button
                onClick={() => {
                  handleFinishconsultation(customerdata?._id);
                  setConfirmFinishDialog(false);
                }}
                className="add-btn"
              >
                Yes, Finish
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </>

    </>
  );
};

export default ViewConsultationInfo;
